// extracted by mini-css-extract-plugin
module.exports = {"listIcon":"list-icon_listIcon__Hr61I","item":"list-icon_item__37753","text":"list-icon_text__W_tT4"};